import * as React from 'react';
import clsx from 'clsx';

import { IconCrossLarge } from '@tocktix/pantry';
import IconButton from '@tock/shared/components/buttons/IconButton';

interface Props {
  children?: React.ReactNode;
  modifierClassName?: string;
  heading: string | JSX.Element | JSX.Element[];
  beforeHeader?: JSX.Element;
  onClose(): void;
  leftJustifyHeading?: boolean;
}
/**
 * @deprecated Use ui/DialogTitle with ui/Dialog instead
 */
function ComposableModalHeading({
  beforeHeader,
  heading,
  onClose,
  children,
  modifierClassName,
  leftJustifyHeading = false,
}: Props) {
  const className = clsx('ComposableModalHeading', modifierClassName);
  const headingClassName = clsx(
    'ComposableModalHeading-title',
    leftJustifyHeading && 'left-justify-heading-title'
  );

  return (
    <div className={className}>
      {beforeHeader && beforeHeader}
      <h1 className={headingClassName}>{heading}</h1>
      {children}
      <IconButton
        variant="borderless"
        modifierClassName={clsx(
          'ComposableModalHeading-close Button--autosize ignore-react-onclickoutside'
        )}
        onClick={onClose}
        IconComponent={IconCrossLarge}
        iconSize="large"
        hideText
        text="Close"
      />
    </div>
  );
}

export default ComposableModalHeading;
